// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"fab40a1b068615a5f68d","293":"d17fe760259be3979d9b"}[chunkId] + ".js";
};